import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "titleDD" }, "Información financiera", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { style: {"color":"#706262"} }, "La información que ingrese a continuación debe corresponder al año fiscal inmediatamente. Ten en cuenta que esta información es necesaria para finalizar el proceso, por lo anterior no omitas el diligenciamiento de todos los campos.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "top",
    "label-width": "auto",
    class: "greenItem"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Ventas o ingresos operacionales" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.VentasIngresosOperacionales,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objetoFinanciera.VentasIngresosOperacionales) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Total de activos" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.TotalActivos,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objetoFinanciera.TotalActivos) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Egresos" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.Egresos,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objetoFinanciera.Egresos) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Ingresos no operacionales" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.IngresosNoOperacionales,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objetoFinanciera.IngresosNoOperacionales) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Otros activos" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.OtrosActivos,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objetoFinanciera.OtrosActivos) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Total pasivos" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.TotalPasivos,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objetoFinanciera.TotalPasivos) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Total ingresos" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.TotalIngresos,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objetoFinanciera.TotalIngresos) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Descripción otros activos" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoFinanciera.DescripcionOtrosActivos,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objetoFinanciera.DescripcionOtrosActivos) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Activos totales" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.ActivosTotales2,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.objetoFinanciera.ActivosTotales2) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Gastos Totales" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.GastosTotales,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.objetoFinanciera.GastosTotales) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Gastos financieros" }, {
                default: _withCtx(() => [
                  _createVNode(_component_currency_input, {
                    options: {
              locale: 'pt-BR',
              currency: 'COP',
              currencyDisplay: 'narrowSymbol',
            },
                    modelValue: _ctx.objetoFinanciera.GastosFinancieros,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objetoFinanciera.GastosFinancieros) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Descripción otros ingresos" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoFinanciera.DescripcionOtrosIngresos,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.objetoFinanciera.DescripcionOtrosIngresos) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Descripción ingresos no operacionales" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.objetoFinanciera.DescripcionIngresosNoOperacionales,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.objetoFinanciera.DescripcionIngresosNoOperacionales) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}